import { useState } from 'react'
import { Drawer, Button, Checkbox, Row, Col, Divider, Typography } from 'antd'
import { logUserEvent } from 'helpers/userEventLogger'
import { useOnlineContext } from 'helpers/contexts/OnlineContext/OnlineContext'
import { useEntityData } from 'EntityDataContext/EntityDataContext'
import { getCopyListOptions } from '../utils'

const CopyAssetDrawer = ({
  assets = [],
  open = false,
  onClose = () => {} 
}) => {
  const { userData: { email }, syncStatusHook: { imagesToUploadCount } } = useEntityData()

  const { isOnline } = useOnlineContext()

  const [checkedList, setCheckedList] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkAll, setCheckAll] = useState(false)

  const plainOptions = getCopyListOptions(assets)

  const onChange = list => {
    setCheckedList(list)
    setIndeterminate(!!list.length && list.length < plainOptions.length)
    setCheckAll(list.length === plainOptions.length)
  }

  const onCheckAllChange = e => {
    setCheckedList(e.target.checked ? plainOptions.map((v) => v.value) : [])
    setIndeterminate(false)
    setCheckAll(e.target.checked)
  }

  const onCloseDrawer = (asset = undefined) => {
    setCheckedList([])
    setIndeterminate(false)
    setCheckAll(false)

    logUserEvent({
      user: email,
      eventType: `Copy asset from space drawer closed - ${asset ? 'Assets selected = ' + asset : 'No assets selected'}`,
      imageOutboxSize: imagesToUploadCount
    }, isOnline);

    if (asset) {
      onClose(asset)
    } else {
      onClose()
    }
  }

  return (
    <Drawer
      title="Assets to be copied"
      placement="right"
      onClose={() => onCloseDrawer()}
      open={assets.length > 0 && open}
      className="asset-type-drawer"
      closable={false}
      destroyOnClose
    >
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        Copy All Assets
      </Checkbox>
      <Divider />
      <Checkbox.Group value={checkedList} onChange={onChange}>
        <Row>
          {plainOptions.map((o) => (
            <Col span={24} key={o.value}>
              <Checkbox value={o.value} style={{ width: '100%' }}>
                {o.label}{' '}
                {o.description && (
                  <Typography.Text
                    style={{ maxWidth: 300 }}
                    ellipsis={{
                      tooltip: true,
                    }}
                  >
                    {o.description ? ` - ${o.description}` : null}
                  </Typography.Text>
                )}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
      <Divider />
      <div className="form-buttons">
        <Button
          type="transparent"
          onClick={() => onCloseDrawer()}
        >
          Cancel
        </Button>
        <Button
          disabled={checkedList.length === 0}
          type="primary"
          onClick={() => onCloseDrawer(checkedList)}
        >
          Copy
        </Button>
      </div>
    </Drawer>
  )
}

export default CopyAssetDrawer
